import React from 'react'
import icon1 from '../assets/img/icons/t1.png';
import icon2 from '../assets/img/icons/t2.png';
import QualityandInnovation from '../assets/img/icons/QualityandInnovation.svg';
import SustainabilityandGrowth from '../assets/img/icons/SustainabilityandGrowth.svg';
import Integrityandtrust from '../assets/img/icons/Integrityandtrust.svg';


const Timeline = () => {
  return (
    <section className="company-timeline-wrapper section-padding">
        <div className="container">
            <div className="row mtm-40">
                <div className="col-lg-4  col-md-6 offset-lg-1 pe-lg-0">
                    <div className="timeline-content text-lg-end">
                        <div className="single-timeline-box">
                            <span>1976 - 1990</span>
                            <h6>Establishing the Foundations</h6>
                            <p>Shree Gita Group began its journey in 1976 with a small-scale oil cake manufacturing unit under the visionary leadership of Shri Naginkumar Vallabhdas Bhojani. The foundation was laid with dedication and a commitment to quality, focusing on seed crushing and oil production. </p>
                        </div>
                        <div className="single-timeline-box">
                            <span>1990 - 2005</span>
                            <h6>Scaling New Heights</h6>
                            <p>During this period, the company expanded its operations significantly by introducing a cotton ginning and pressing division and enhancing oil milling capacity. The installation of cutting-edge machinery marked the beginning of Shree Gita Group’s transition into a leading name in agro-industrial production. </p>
                        </div>
                    </div>
                </div>
                <div className="col-lg-2 d-none mt-40 d-lg-block">
                    <div className="time-line-icon">
                        <div className="single-icon">
                            <img src={icon1} alt=""/>
                        </div>
                        <div className="single-icon">
                            <img src={icon2} alt=""/>
                        </div>
                    </div>
                </div>
                <div className="col-lg-4 col-md-6 ps-lg-0">
                    <div className="timeline-content">
                        <div className="single-timeline-box">
                            <span>2005 - 2015</span>
                            <h6>Achieving Global Milestones</h6>
                            <p>The group ventured into international markets, establishing itself as a trusted supplier of agro-commodities worldwide. With the introduction of an edible oil refinery and the expansion of ginning capacity, Shree Gita solidified its position as a key player in the industry. </p>
                        </div>
                        <div className="single-timeline-box">
                            <span>2015-2025</span>
                            <h6>Present: Innovating for the Future</h6>
                            <p>Continuing its legacy of innovation, Shree Gita Group embraced advanced technology and sustainable practices to meet the evolving demands of the global agro market. With a robust supply chain and a diversified portfolio, the company now serves clients ranging from multinational corporations to local manufacturers. </p>
                        </div>
                    </div>
                </div>
            </div>

            <div className="row mt-lg-5 mt-3">
                <div className="col-md-6 col-12 col-lg-4">
                    <div className="single-icon-border-box">
                        <div className="icon">
                            {/* <i className="flaticon-trust"></i> */}
                            <img src={Integrityandtrust} alt=""/>
                        </div>
                        <div className="content">
                            <h6><span>Integrity and  </span>  Trust </h6>
                        </div>
                    </div>
                </div>
                <div className="col-md-6 col-12 col-lg-4">
                    <div className="single-icon-border-box">
                        <div className="icon">
                        <img src={QualityandInnovation} alt=""/>
                        </div>
                        <div className="content">
                            <h6><span>Quality and Innovation </span>  </h6>
                        </div>
                    </div>
                </div>
                <div className="col-md-6 col-12 col-lg-4">
                    <div className="single-icon-border-box">
                        <div className="icon">
                        <img src={SustainabilityandGrowth} alt=""/>
                        </div>
                        <div className="content">
                            <h6><span>Sustainability and Growth</span>   </h6>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
  )
}

export default Timeline